// extracted by mini-css-extract-plugin
export var richText = "richtext-module--rich-text--3ee80";